import { useTranslation } from 'react-i18next';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';

const TABS = [
  { to: 'kalender', key: 'admin.tabs.calendar' },
  { to: 'hutteneinsatz', key: 'admin.tabs.hutDuty' },
  { to: 'dienstplanung', key: 'admin.tabs.dutyPlanning' },
  { to: 'buchungen', key: 'admin.tabs.bookings' },
  { to: 'export', key: 'admin.tabs.export' },
  { to: 'einstellungen', key: 'admin.tabs.settings' },
] as const;

export function AdminDashboard() {
  const { t } = useTranslation();
  const { admin, logout } = useAuth();

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h1 className="text-xl sm:text-2xl font-semibold">{t('admin.dashboard.title')}</h1>
        <div className="flex items-center gap-3 text-sm">
          {admin && (
            <span className="text-slate-600 dark:text-slate-400">
              {t('admin.dashboard.signedInAs', { username: admin.username })}
            </span>
          )}
          <button
            type="button"
            onClick={() => void logout()}
            className="rounded-md border border-slate-300 bg-white text-slate-700 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-200 font-medium px-3 py-1.5"
          >
            {t('admin.dashboard.logout')}
          </button>
        </div>
      </div>

      <nav
        aria-label={t('admin.dashboard.title')}
        className="flex gap-1 overflow-x-auto border-b border-slate-200 dark:border-slate-700 -mx-3 px-3 sm:mx-0 sm:px-0"
      >
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              'whitespace-nowrap px-3 py-2 text-sm font-medium border-b-2 -mb-px ' +
              (isActive
                ? 'border-slate-900 text-slate-900 dark:border-slate-100 dark:text-slate-100'
                : 'border-transparent text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-200')
            }
          >
            {t(tab.key)}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
